const timePeriodTypes = {
  ALL: 1,
  WEEKDAY: 2,
  WEEKEND: 3,
  MON: 4,
  TUE: 5,
  WED: 6,
  THU: 7,
  FRI: 8,
  SAT: 9,
  SUN: 10,
};

const timePeriodTypeDetails = {
  [timePeriodTypes.ALL]: {
    code: 'ALL', display: 'Every Day', order: null,
  },
  [timePeriodTypes.WEEKDAY]: {
    code: 'WEEKDAY', display: 'Week Days', order: null,
  },
  [timePeriodTypes.WEEKEND]: {
    code: 'WEEKEND', display: 'Weekends', order: null,
  },
  [timePeriodTypes.MON]: {
    code: 'MON', display: 'Monday', order: 1,
  },
  [timePeriodTypes.TUE]: {
    code: 'TUE', display: 'Tuesday', order: 2,
  },
  [timePeriodTypes.WED]: {
    code: 'WED', display: 'Wednesday', order: 3,
  },
  [timePeriodTypes.THU]: {
    code: 'THU', display: 'Thursday', order: 4,
  },
  [timePeriodTypes.FRI]: {
    code: 'FRI', display: 'Friday', order: 5,
  },
  [timePeriodTypes.SAT]: {
    code: 'SAT', display: 'Saturday', order: 6,
  },
  [timePeriodTypes.SUN]: {
    code: 'SUN', display: 'Sunday', order: 7,
  },
};

const isGlobalTimePeriodType = (timePeriodTypeId) => [
  timePeriodTypes.ALL,
  timePeriodTypes.WEEKDAY,
  timePeriodTypes.WEEKEND,
].includes(timePeriodTypeId);

export {
  timePeriodTypes,
  timePeriodTypeDetails,
  isGlobalTimePeriodType,
};
